export * from './berichts-vorlagen-sorter.component';
export * from './berichts-vorlagen-sorter.component.module';